import { render, staticRenderFns } from "./BirthDatePicker.vue?vue&type=template&id=2623585d&"
import script from "./BirthDatePicker.vue?vue&type=script&lang=js&"
export * from "./BirthDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports